import { ListaSuspensa } from "./ListaSuspensa";

export default ListaSuspensa;